'use client';

import { mapDisplay, text } from '@mage-ui/styled-system/recipes';
import { APIProvider, Map as ReactMap } from '@vis.gl/react-google-maps';
import { parseMap } from 'utils/parseMap';
import { Section } from '../../layouts/sections/Section';
import { MapMarker } from '../map-marker/MapMarker';

export const MapDisplay = ({ data, apiKey, ...props }) => {
  const locations =
    data?.fields?.locations ?? data?.relations?.LocationsList ?? [];

  const defaultCenter =
    locations?.length > 0
      ? parseMap(locations[0].map || locations[0].fields?.map)
      : { lat: 41.3768971, lng: 2.1734266 };

  const textClass = text({ size: '2', weight: 'bold' });

  return (
    <Section className={mapDisplay().root} {...props}>
      {locations?.length > 0 && (
        <div className={mapDisplay().contentWrapper}>
          {locations?.map((addr) => (
            <address key={addr?.title || addr?.fields?.title}>
              <ul>
                {(addr?.title || addr?.fields?.title) && (
                  <li className={textClass}>
                    {addr?.title || addr?.fields?.title}
                  </li>
                )}
                {(addr?.direction || addr?.fields?.direction) && (
                  <li className={textClass}>
                    {addr?.direction || addr?.fields?.direction}
                  </li>
                )}
                {(addr?.city || addr?.fields?.city) && (
                  <li className={textClass}>
                    {addr?.city || addr?.fields?.city}
                  </li>
                )}
              </ul>
            </address>
          ))}
        </div>
      )}
      <div className={mapDisplay().mapWrapper}>
        <APIProvider apiKey={data?.meta?.map_key || apiKey} version={'beta'}>
          <ReactMap
            defaultZoom={17}
            defaultCenter={defaultCenter}
            mapId={data?.meta?.map_id || data?.meta?.map_key || data?.meta?.key}
          >
            {locations?.map((marker) => (
              <MapMarker
                key={marker?.map || marker?.meta?.key}
                point={marker}
              />
            ))}
          </ReactMap>
        </APIProvider>
      </div>
    </Section>
  );
};
